var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-switch',{attrs:{"onText":_vm.$t('COMMON.YES'),"offText":_vm.$t('COMMON.NO'),"disabled":_vm.disabled},model:{value:(_vm.fieldValue),callback:function ($$v) {_vm.fieldValue=$$v},expression:"fieldValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }